import { message } from 'antd';
import type { FormInstance } from 'antd/es/form';
import type { RcFile, UploadFile } from 'antd/es/upload/interface';
import axios from 'axios';
import type { UploadRequestOption } from 'rc-upload/lib/interface';

import type { Uploads } from '@/types/database/uploads';

import { TimeUnit } from '../../constants';
import type { CleanKindFetchResponse } from '../../sharedTypes';
import type { InformationFormDataType } from '../types';

export const limitRuleUnits = [
  { label: '天', value: TimeUnit.Day },
  { label: '週', value: TimeUnit.Week },
  { label: '月', value: TimeUnit.Month },
];

const uploadFiles = async (file: string | Blob | RcFile) => {
  const formData = new FormData();
  formData.append('files', file);
  const response = await axios.post<Uploads>(
    '/newUploads?type=cleanKind',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        authorization: localStorage.getItem('feathers-jwt'),
      },
    }
  );
  return response;
};

export const customRequest = async (
  options: UploadRequestOption,
  updatePicture: (newPicture: UploadFile<Uploads>) => void
) => {
  const { onSuccess, file } = options;
  try {
    const response = await uploadFiles(file);
    if (onSuccess) {
      onSuccess(response.data);
      const { _id, oldName, showPath } = response.data[0];
      const newPicture = {
        ...response.data[0],
        name: oldName,
        url: showPath,
        uid: _id,
        thumbUrl: showPath,
      };
      updatePicture(newPicture);
    }
  } catch (error) {
    message.error('圖片上傳失敗!');
  }
};

export const setFormValues = (args: {
  cleanKindData: CleanKindFetchResponse;
  uploads: Uploads[];
  form: FormInstance<InformationFormDataType>;
}) => {
  const { cleanKindData, uploads, form } = args;

  const { name, picture, janitor, memberReservationLimit } = cleanKindData;
  const foundUploadedFile = uploads.find(
    (upload) => upload.showPath === picture
  );
  const formValues = {
    ...cleanKindData,
    cleanKindName: name,
    picture: foundUploadedFile
      ? [
          {
            ...foundUploadedFile,
            name: foundUploadedFile.oldName,
            url: foundUploadedFile.showPath,
            uid: foundUploadedFile._id,
            thumbUrl: foundUploadedFile.showPath,
          },
        ]
      : [],
    janitor: janitor.kind,
    partnerName: janitor.kind === 'Partner' ? janitor.partnerId : null,
    reservationLimitRule: memberReservationLimit.kind,
    limitRuleValue:
      memberReservationLimit.kind === 'None'
        ? null
        : memberReservationLimit.duration,
    limitRuleUnit:
      memberReservationLimit.kind === 'None'
        ? null
        : memberReservationLimit.unit,
  };

  form.setFieldsValue(formValues);
};
